import React from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import BottomNav from './BottomNav';
import useRoleTheme from '../../hooks/useRoleTheme';

const MainLayout = () => {
  useRoleTheme();
  return (
    <Container>
      <Content>
        <Outlet />
      </Content>
      <BottomNav />
    </Container>
  );
};

export default MainLayout;

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  position: relative;
`;

const isRnWebView = !!window.ReactNativeWebView;

const Content = styled.main`
  padding-bottom: ${isRnWebView ? '128px' : '80px'};
`;
